import { Component, HostBinding, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldConfig } from "app/genericForm/field.interface";
@Component({
  selector: "app-select-multiple",
  template: `
      <div class="row">
        <mat-form-field class="col-12 demo-full-width margin-top" [formGroup]="group" >
          <mat-select [placeholder]="field.label" [formControlName]="field.name" multiple>
          <mat-option *ngFor="let item of field.options" [value]="item">{{item[field.description]}}</mat-option>
          </mat-select>
        </mat-form-field>
    </div>
`,
  styles: []
})
export class MultipleSelectComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  @HostBinding('class') class = '';
  constructor() {
  }
  ngOnInit() {
    this.class = this.field.claseGrillaBootstrap;
    if (this.field.value) {
      let valoresSeleccionados = [];
      for (const valorPreseleccionado of this.field.value) {
        let valorTmp = this.field.options?.filter(option => {
          let pepe = option[this.field.id] === valorPreseleccionado[this.field.id];
          return pepe;
        });
        valoresSeleccionados.push(valorTmp[0]);
      }
      this.group.controls[this.field.name].patchValue(valoresSeleccionados);
    }
  }
}
